import React, { useState } from "react";
import { Button, Checkbox, Col, Form, Row } from "antd";
import CommentBox from "../../../components/commentBox";
import TaskCheckedList from "../../../components/taskCheckedList";
import PageHeader from "../../../components/pageHeader";
import { collection, doc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "../../../../../../../firebase";

function VerifyProratedRentPaid({ itemId, listId, alreadyCheckedItems }) {
  const isItemChecked = alreadyCheckedItems[itemId.toString()]; // Convert itemId to string because keys in checkedItems are strings.

  const [isDisabled, setIsDisabled] = useState(isItemChecked);

  const tasksRef = collection(db, "tasks");
  const itemListRef = doc(tasksRef, "itemList");
  const assignedCollectionRef = collection(itemListRef, "Assigned");

  function handleUndefinedValues(obj) {
    const newObj = {};
    for (let key in obj) {
      newObj[key] = obj[key] === undefined ? false : obj[key];
    }
    return newObj;
  }

  const onFinish = async (values) => {
    console.log("Success:", values);
    values = handleUndefinedValues(values);
    const targetDocRef = doc(assignedCollectionRef, listId);

    try {
      const docSnapshot = await getDoc(targetDocRef);

      if (docSnapshot.exists()) {
        const data = docSnapshot.data();
        if (data && data.workItemList) {
          const updatedWorkItemList = data.workItemList.map((item) => {
            return {
              ...item,
              status:
                item.id == itemId && item.status == "incompleted"
                  ? "completed"
                  : item.status,
              details: item.id == itemId && values,
            };
          });

          await updateDoc(targetDocRef, {
            workItemList: updatedWorkItemList,
          });

          console.log("Document successfully updated!");
          setIsDisabled(true);
        } else {
          console.log("workItemList not found in the document!");
        }
      } else {
        console.log("Document does not exist!");
      }
    } catch (error) {
      console.error("Error updating document:", error);
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };
  return (
    <div className="item-page">
      <Form
        className="item-page-container"
        colon={false}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
      >
        <Row gutter={[0, 24]}>
          <Col span={24}>
            <PageHeader pageHeading="Verify prorated rent paid" />
          </Col>
          <Col span={24}>
            <Form.Item label="1" name="verifyPaid" valuePropName="checked">
              <Checkbox>
                Verify that pro rated rent and SD have been paid
              </Checkbox>
            </Form.Item>
            <Form.Item label="2" name="completeMoveIn" valuePropName="checked">
              <Checkbox>Mark move in complete in sayeagle</Checkbox>
            </Form.Item>
            <Form.Item
              label="3"
              name="verifyRecentInspection"
              valuePropName="checked"
            >
              <Checkbox>
                Verify there is a recent inspection done if not do one now
              </Checkbox>
            </Form.Item>
          </Col>
          <Col span={24}>
            <p className="red-heading">
              Add the following tags on the tenant page in appfolio as needed
            </p>
          </Col>
          <Col span={24}>
            <p className="red-heading">-2 pets</p>
          </Col>
          <Col span={24}>
            <p className="red-heading">-1 pet</p>
          </Col>
          <Col span={24}>
            <p className="red-heading">-1 service animal</p>
          </Col>
          <Col span={24}>
            <p className="red-heading">-2 service animals</p>
          </Col>
          <Col span={24}>
            <p className="red-heading">
              this will help us track who should have a pet going forward
            </p>
          </Col>
          <Col span={24}>
            <Row justify="end" gutter={[8, 0]}>
              <Col>
                <Button>Skip</Button>
              </Col>
              <Col>
                <Button type="primary" htmlType="submit" disabled={isDisabled}>
                  Complete
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <CommentBox />
          </Col>
          <Col span={24}>
            <TaskCheckedList />
          </Col>
        </Row>
      </Form>
    </div>
  );
}

export default VerifyProratedRentPaid;
